/* eslint-disable react/jsx-key */
import { useTableHeadersHook } from '@/hooks';
import { ITable } from '@/types/types';
import { FC } from 'react';
import { useTable } from 'react-table';

interface TableProps {
  dataArr: ITable[];
  className?: string;
}

export const Table: FC<TableProps> = ({ dataArr, className }) => {
  const columns = useTableHeadersHook();

  const tableInstance = useTable({ columns, data: dataArr });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance;

  return (
    <table
      className={`table-auto mdOnly:text-sm lg:text-md ${className}`}
      {...getTableProps()}
    >
      <thead className="bg-accentMain text-white dark:bg-accentAdditional dark:text-darkFullDark">
        {headerGroups.map(headerGroup => (
          <tr className="h-[100px]" {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th
                className="py-5 pl-4 pr-2 text-start font-normal mdOnly:py-4 mdOnly:pl-3 "
                {...column.getHeaderProps()}
              >
                {column.render('Header')}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map(row => {
          prepareRow(row);
          return (
            <tr className="even:bg-table" {...row.getRowProps()}>
              {row.cells.map(cell => (
                <td className="py-5 pl-4 pr-2" {...cell.getCellProps()}>
                  {cell.render('Cell')}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
